import React from "react"
import { useSettings } from "../editor"

export default function BackgroundImage({
  setting,
  size,
  width,
  spaceSetting,
  height,
  fallbackBgColor,
  children,
  ...props
}) {
  const settings = useSettings()
  const imgSrc = settings.find(s => s.name === setting).value
  const backgroundSize = settings.find(s => s.name === size)?.value || "cover"
  if (spaceSetting) {
    const space = settings.find(s => s.name === spaceSetting).value
    width = space === "thin" ? "600" : "100%"
  }
  const msoWrap = html => "</div><!--[if mso]>" + html + "<![endif]--><div>"
  const msoStart = `
      <xml xmlns:o="urn:schemas-microsoft-com:office:office"><o:OfficeDocumentSettings><o:AllowPNG/><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml>
      <table height="100%" width="100%" cellpadding="0" cellspacing="0" border="0">
        <tr>
          <td valign="top" align="left" style="word-break:break-all;background-image:url('${imgSrc}');background-repeat:no-repeat">
            <v:rect xmlns:v="urn:schemas-microsoft-com:vml" fill="true" stroke="false" style="width: ${width}; height: ${height};">
              <v:fill type="frame" src="${imgSrc}" color="${fallbackBgColor}" aspect="atleast" origin="0,0" position="0,0" />   
              <v:textbox inset="0,0,0,0">`
  const msoEnd = "</v:textbox></v:rect></td></tr></table>"

  return (
    <>
      <div
        style={{
          backgroundImage: `url('${imgSrc}')`,
          backgroundSize: backgroundSize,
          backgroundRepeat: "no-repeat"
        }}
        {...props}
      >
        <div dangerouslySetInnerHTML={{ __html: msoWrap(msoStart) }} />
        {children}
        <div dangerouslySetInnerHTML={{ __html: msoWrap(msoEnd) }} />
      </div>
    </>
  )
}
